import React from 'react'
import SarasTrans from '../../notifications/SarasTrans'

const FormTitle = (props) => {
    const { formObject, value} = props;

    const getTitle = () => {
        var title;
        if(formObject.masterKeys && formObject.masterKeys.dataList)
            title = formObject.masterKeys.dataList.compositionName 
                    || formObject.masterKeys.dataList.sectionTitle 
                    || value
                    || formObject.masterKeys.docTypeName
        else
            title = value
        return title
    }

    var title = getTitle()

    return(
        <span><SarasTrans value={title} /></span>
    )
}

export default FormTitle